import React, { useState, useEffect } from 'react';
import { Tab, Nav, Container, Button, Form, Row, Col } from 'react-bootstrap';
import RewardsTabbedForm from './RewardsTabbedForm';

const categories = {
    "Employer Information": [
        "Legal Employer Name",
        "Employer company"
    ],
    "Personal Identification": [
        "Person Number",
        "Surname",
        "First Names",
        "Known As",
        "Title",
        "Person Date of Birth",
        "Gender",
        "Marital Status",
        "Nationality",
        "Primary National Identifier Number",
        "Passport Country",
        "Passport Expiry Date"
    ],
    "Contact Information": [
        "Email Address",
        "Address Line 1",
        "City",
        "Country",
        "Region 1",
        "Region 2"
    ],
    "Employment Dates": [
        "Enterprise Hire Date",
        "Current Legal Employer Hire Date",
        "Work Relationship Start Date",
        "Termination Date"
    ],
    "Assignment Details": [
        "Assignment Identifier",
        "Assignment Number",
        "Assignment Category",
        "Assignment Start Date",
        "Assignment End Date",
        "Assignment Status",
        "Assignment Status Type",
        "Full/Part Time",
        "Assignment Primary Flag",
        "Probation Period",
        "Probation End Date",
        "Synchronize From Position"
    ],
    "Job and Position": [
        "Business Unit Name",
        "Job",
        "Job Family",
        "Job Code",
        "Reward Level",
        "Department",
        "Location Name",
        "Position Code",
        "Position"
    ],
    "Manager Information": [
        "Manager Flag",
        "Manager Employee Number",
        "Manager Name"
    ],
    "Person Type": [
        "System Person Type",
        "User Person Type"
    ],
    "Compensation and Payroll": [
        "Payroll",
        "Tax Number",
        "Bonus Agreement Score"
    ],
    "Performance and Service": [
        "Years of service",
        "Restraint flag",
        "Notice period",
        "IPF score",
        "Talent outcome score"
    ]
};

const AdminForm = ({ initialData = {} }) => {
    const [formData, setFormData] = useState(initialData);

    useEffect(() => {
        setFormData(initialData);
    }, [initialData]);

    const handleChange = (category, field, value) => {
        if (category === "Reward Details") {
            setFormData(prev => ({
                ...prev,
                [category]: value
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                [category]: {
                    ...prev[category],
                    [field]: value
                }
            }));
        }
    };

    const handleSubmit = e => {
        e.preventDefault();
        console.log("Submitted data:", formData);
    };

    return (
        <div className="mt-4">
            <Form onSubmit={handleSubmit}>
                <Tab.Container defaultActiveKey={Object.keys(categories)[0]}>
                    <Nav variant="tabs" className="mb-3">
                        {Object.keys(categories).map((category, index) => (
                            <Nav.Item key={index}>
                                <Nav.Link eventKey={category}>{category}</Nav.Link>
                            </Nav.Item>
                        ))}
                        <Nav.Item>
                            <Nav.Link eventKey="Reward Details">Reward Details</Nav.Link>
                        </Nav.Item>
                    </Nav>
                    <Tab.Content>
                        {Object.entries(categories).map(([category, fields]) => (
                            <Tab.Pane eventKey={category} key={category}>
                                <Row>
                                    {fields.map((field, idx) => (
                                        <Form.Group as={Col} md="6" key={idx} className="mb-3">
                                            <Form.Label>{field}</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={formData[category]?.[field] || ''}
                                                onChange={e => handleChange(category, field, e.target.value)}
                                            />
                                        </Form.Group>
                                    ))}
                                </Row>
                            </Tab.Pane>
                        ))}
                        <Tab.Pane eventKey="Reward Details">
                            <RewardsTabbedForm
                                key={formData["Personal Identification"]?.["Person Number"] || 'reward-form'}
                                value={formData["Reward Details"] || {}}
                                onChange={val => handleChange("Reward Details", null, val)}
                            />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
                <div className="text-end mt-4">
                    <Button type="submit">Submit</Button>
                </div>
            </Form>
        </div>
    );
};

export default AdminForm;
